module.exports = __webpack_public_path__ + "img/00027.2128667d.webp";